
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAdminUserSessionAsync } from '../../../app/store/reducers/auth/authReducer';
import SessionCard from './components/SessionCard';
import EventBus from '../../../app/eventBus/EventBus';
import { ADMIN_SESSION_REMOVE_SUCCESS } from '../../../app/eventBus/authEvents/authEvents';
import { Row, Col } from 'antd';



const AdminView = () => {
    const {id} = useParams()
    const [session, setSession] = useState(null)
  
    
    const loadSession = async (id) => {
        await getAdminUserSessionAsync({id})
        .then((response) => {
            setSession(response)
        })
        .catch((error) => {
            setSession(null)
        })
    }
  
    useEffect(() => {
        loadSession(id)
        EventBus.on(ADMIN_SESSION_REMOVE_SUCCESS, () => {
            loadSession(id)
        })


        return () => {
            EventBus.remove(ADMIN_SESSION_REMOVE_SUCCESS)
        }
    },[id])
  
  
    if (!session) {
      return <>loading...</>
    }


    return (
    <>
        <h1>Sessions</h1>
        <Row className="d-flex justify-content-around">
        {session?.tokens?.map((ses,i) => {
            return (
                <Col key={i} className="my-2">
                    <SessionCard session={ses} />
                </Col>
            )
        })}
        </Row>
    </>
  )
}

export default AdminView